<template>
    <div class="flex items-center min-h-screen text-white gradient">
        <div class="container flex flex-wrap items-center p-4 mx-auto">
            
            <div class="w-full p-4 text-center md:w-7/12 md:text-left">
                <div class="text-6xl font-medium">
                    404
                </div>
                <div class="mb-4 text-xl font-medium md:text-3xl">
                    Oops. Deze pagina bestaat niet!
                </div>
                <div class="mb-8 text-lg">
                    Misschien heb je een typfout gemaakt?
                </div>
                <router-link to="/" class="p-4 border border-white hover:bg-purple-400">Home</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        }
</script>

<style>
    .gradient {
        background-image: linear-gradient(135deg, #684ca0 35%, #1c4ca0 100%);
    }
</style>